import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import type { HistoryColumn, HistoryRow } from './types';

interface HistoryTableProps {
  columns: HistoryColumn[];
  rows: HistoryRow[];
  /** Keep the header visible while the modal body scrolls. */
  stickyHeader?: boolean;
  /** Message shown under the headers when there are no rows. */
  empty?: string;
}

export function HistoryTable({ columns, rows, stickyHeader = false, empty = 'No records yet.' }: HistoryTableProps) {
  const align = (column?: HistoryColumn) => (column?.align === 'right' ? 'text-right' : undefined);

  return (
    <div className={cn('rounded-lg border border-gray-200 bg-white', !stickyHeader && 'overflow-x-auto')}>
      <Table containerClassName={cn(stickyHeader && 'overflow-visible')}>
        <TableHeader className={cn(stickyHeader && 'sticky top-0 z-10')}>
          <TableRow className="bg-gray-50 hover:bg-gray-50">
            {columns.map((column, index) => (
              <TableHead key={`${column.label}-${index}`} className={cn('h-9 bg-gray-50 text-xs font-semibold text-gray-800', align(column))}>
                {column.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 && (
            <TableRow className="hover:bg-transparent">
              <TableCell colSpan={columns.length} className="py-10 text-center text-sm text-gray-500">
                {empty}
              </TableCell>
            </TableRow>
          )}
          {rows.map((row) => (
            <TableRow key={row.key} className="border-gray-100 text-[13px] tabular-nums">
              {row.cells.map((cell, index) => (
                <TableCell key={index} className={align(columns[index])}>
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
